<div class = "row my-row pt-5 pb-5">
    <div class='container-fluid my-container'>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-sm-3 py-3">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title font-weight-bold">
                            {{ "SUPER-ADMIN.SIDE-MENU.PS-ADMIN" | translate }}
                            <em class="bi bi-person icon-wrapper-settings"></em>
                        </h5>
                        <p class="card-text">{{ 'SUPER-ADMIN.HOME.PS-TEXT' | translate }}</p>
                    </div>
                    <div class='card-footer bg-white'>
                        <a class="btn btn-primary" [routerLink]="'psAdmin'">{{ "SUPER-ADMIN.SIDE-MENU.PS-ADMIN" | translate }}</a>
                    </div>
                </div>
            </div>

            <div class="col-sm-3 py-3">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title font-weight-bold">
                            {{ "SUPER-ADMIN.SIDE-MENU.CLIENT-ADMIN" | translate }}
                            <em class="bi bi-building icon-wrapper-settings"></em>
                        </h5>
                        <p class="card-text">{{ 'SUPER-ADMIN.HOME.CLIENT-TEXT' | translate }}</p>
                    </div>
                    <div class='card-footer bg-white'>
                        <a class="btn btn-primary" [routerLink]="'clientAdmin'">{{ "SUPER-ADMIN.SIDE-MENU.CLIENT-ADMIN" | translate }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
